import React from 'react';
import './Logo.css';
import logoImage from '../images/icons/good_icons/icon.png';

function Logo({ onClick, isClickable = false }) {
  const className = `logo-container${isClickable ? ' logo-container-clickable' : ''}`;
  return (
    <div className={className} onClick={onClick} role={isClickable ? 'button' : undefined}>
      <div className="ripple ripple-1"></div>
      <div className="ripple ripple-2"></div>
      <div className="ripple ripple-3"></div>
      <div className="ripple ripple-4"></div>
      <div className="logo-ring"></div>
      <div className="logo">
        <img src={logoImage} alt="Rocket VPN" className="logo-image" />
      </div>
    </div>
  );
}

export default Logo;

